<template>
  <AppImg
    :src="img.src"
    :alt="$tt('hero_img')"
    fetchpriority="high"
    eager preload
  />
</template>

<script setup lang="ts">
import type { Image } from '~/types';

defineProps<{
  img: Image;
}>();
</script>